export default "__VITE_ASSET__Dz$By8MN__"